"use client";

import { createContext, type ReactNode, useContext } from "react";

const AppBuildIdContext = createContext<string | null>(null);

interface AppBuildIdProviderProps {
  buildId: string | null;
  children: ReactNode;
}

export function AppBuildIdProvider({ buildId, children }: AppBuildIdProviderProps) {
  return <AppBuildIdContext.Provider value={buildId}>{children}</AppBuildIdContext.Provider>;
}

/** The id of the build that rendered this page, or null outside a production build. */
export function useAppBuildId(): string | null {
  return useContext(AppBuildIdContext);
}
